<!-- <div class="card border outline-variant rounded-4 bg-transparent" style="min-height: 230px" *ngIf="!nextTab">
    <div class="card-body d-flex align-items-center justify-content-center">
      <button type="button" class="btn btn-success w-md" (click)="openUsersSelector(botsSelector)">Select Menu</button>
    </div>
  </div> -->
<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row mb-3">
      <label for="bg-color" class="offcanvas-header-text col-6 m-0 d-flex align-items-center" style="text-align: left;"> Select Appbar</label>
      <div class="col-6 d-flex justify-content-end" *ngIf="!nextTab">
        <button type="button" class="btn btn-primary" (click)="openUsersSelector(botsSelector)">Select Appbar</button>
      </div>
    </div>

    <div class="card mb-0 py-3 border outline-variant rounded-4 mb-3 bg-transparent" *ngIf="nextTab">
      <div class="row m-0">
        <div class="col-4 col-sm-4 col-md-4 col-xxl-4 d-flex justify-content-center">
          <app-mobile-view-slider
            *ngIf="menu"
            class="border outline-variant shadow-sm rounded-3 overflow-hidden"
            [enableStatic]="true"
            [fontSmaller]="true"
            [inputMenuId]="menu?.menu_id"
            [inputTab]='nextTab'
            [stat]='nextTab'
            [inputTab]='nextTab'
            [colors]="colors">
          </app-mobile-view-slider>

          <!-- <app-mobile-view-tab [inputTab]="nextTab" [fontSmaller]="true" *ngIf="nextTab" class="border outline-variant shadow-sm rounded-3 overflow-hidden"></app-mobile-view-tab> -->
        </div>
        <div class="col-8 col-sm-8 col-md-8 col-xxl-8 ps-0 pe-3 py-2">
          <div class="row h-100">
            <div class="col-12">
              <div class="row">
                <div class="col-12 d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <!-- <div class="card-dim-bg rounded-3 p-1 me-2">
                      <i class="material-icons font-size-24 p-2">menu</i>
                    </div> -->
                    <div *ngIf="menu" class="d-flex flex-column">
                      <span class="fw-bolder mb-1 mt-2 offcanvas-header-text">{{ menu.menu_name? menu?.menu_name:menu?.menu_id}}</span>
                      <!-- <span class="font-size-12 text-muted">Category: {{nextTab?.web?.category}}</span> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="d-flex align-items-center">
                    <div class="me-2">
                      <i class="invisible rounded-3 p-3 font-size-20 material-icons border outline-variant">chat</i>
                    </div>
                    <span class="text-muted font-size-12">
                      {{nextTab?.web?.desc}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex align-items-end">
              <div
                class="d-flex align-items-center justify-content-center justify-content-md-end w-100 pe-lg-0 pe-sm-4 pe-xs-4">
                <!-- <button *ngIf="nextTab.module == tabNames?.MENU" class="btn success-button btn-md btn-rounded position-relative me-2 fw-bold px-4 bottom-0 text-dark" (click)="goToWorkflow(nextTab)">
                    Setup
                  </button>

                  <button *ngIf="nextTab.module == tabNames?.PAGE" class="btn success-button btn-md btn-rounded position-relative me-2 fw-bold px-4 bottom-0 text-dark" (click)="goToPage(nextTab)">
                    Setup
                  </button>

                  <button *ngIf="nextTab.module == tabNames?.STORE" class="btn success-button btn-md btn-rounded position-relative me-2 fw-bold px-4 bottom-0 text-dark" (click)="goToStore(nextTab)">
                    Setup
                  </button>

                  <button *ngIf="nextTab.module == tabNames?.MARKET" class="btn success-button btn-md btn-rounded position-relative me-2 fw-bold px-4 bottom-0 text-dark" (click)="goToMarket(nextTab)">
                    Setup
                  </button>

                  <button *ngIf="nextTab.module == tabNames?.POLL" class="btn success-button btn-md btn-rounded position-relative me-2 fw-bold px-4 bottom-0 text-dark" (click)="goToPoll(nextTab)">
                    Setup
                  </button>

                  <button *ngIf="nextTab.module == tabNames?.QUERY" class="btn success-button btn-md btn-rounded position-relative me-2 fw-bold px-4 bottom-0 text-dark" (click)="goToSearch(nextTab)">
                    Setup
                  </button> -->

                <button class="cta border-0 position-relative me-2" (click)="deleteTab()">
                  <i class="fas fa-trash-alt"></i>
                  <span class="button-text fw-bold">Delete</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #botsSelector let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="selector">{{ config?.name }}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body p-0">
    <!-- <app-bar-selector
      [single]="true"
      [chatID]="mainChat"
      [type]="'appbar'"
      [selectedBots]="selectedBots"
      (selectedNotifier)="selectedUsersf($event)"
      (cancelNotifier)="modalRef.hide()"
    ></app-bar-selector> -->

    <app-screen-selector [screens]="['appbar']" (selectedItemNotify)="onSelectScreen($event)"></app-screen-selector>
  </div>
</ng-template>
